import "./instrument";

import $ from "jquery";
import moment from "moment";
import * as Sentry from "@sentry/react";
declare global {
  interface Window {
    $: typeof $;
    jQuery: typeof $;
    moment: typeof moment;
  }
}

// Store reference to CDN jQuery if it exists (loaded from index.html)
const cdnJQuery = window.$ as any;

// Set up npm jQuery and moment globally
// This ensures any plugins attach to the correct jQuery instance
window.$ = $;
window.jQuery = $;
window.moment = moment;

// If CDN jQuery had daterangepicker attached, copy it to npm jQuery
if (
  cdnJQuery &&
  typeof cdnJQuery.fn !== "undefined" &&
  typeof (cdnJQuery.fn as any).daterangepicker !== "undefined"
) {
  // Copy the daterangepicker plugin from CDN jQuery to npm jQuery
  ($.fn as any).daterangepicker = (cdnJQuery.fn as any).daterangepicker;
}

// Import bootstrap-daterangepicker AFTER jQuery is set up
// This ensures the plugin attaches to our jQuery instance if not already copied from CDN
import "bootstrap-daterangepicker/daterangepicker";

import { initLocation } from "./hooks/initLocation";
import ReactDOM from "react-dom/client";
import App from "./App";
import ErrorFallback from "./components/ErrorFallback";
// eslint-disable-next-line no-undef
const environment = (process.env.NODE_ENV || "").toLowerCase();

if (
  environment === "client" ||
  environment === "production" ||
  environment === "qa" ||
  environment === "cli" ||
  environment === "prod"
) {
  console.log = function () {};
  console.warn = function () {};
  console.error = function () {};
  console.info = function () {};
  console.debug = function () {};
}

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <Sentry.ErrorBoundary
    fallback={({ resetError, eventId }) => (
      <ErrorFallback resetError={resetError} eventId={eventId} />
    )}
  >
    <App />
  </Sentry.ErrorBoundary>,
);
